import ApiService from "@/core/services/api.service";

export async function fetchEscPosPayload(saleId) {
  return ApiService.get(`pos/escpos/${saleId}`);
}

export async function printEscPos(saleId) {
  const payload = await fetchEscPosPayload(saleId);
  if (!payload?.data) return false;

  const raw = atob(payload.data);
  const blob = new Blob([Uint8Array.from(raw, (c) => c.charCodeAt(0))], {
    type: "application/octet-stream",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `receipt-${saleId}.bin`;
  a.click();
  URL.revokeObjectURL(url);
  return true;
}

export async function openCashDrawer(saleId) {
  const payload = await fetchEscPosPayload(saleId);
  if (!payload?.openDrawerCommand) return false;
  return true;
}
